import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed, ref } from "vue";
import { useAppStore } from "@/ts/stores/app";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { HamburgerButton } from "@/ts/components/elements";

interface Props {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    alternateHover: boolean;
    facebookUrl?: string;
    instagramUrl?: string;
    twitterUrl?: string;
    theme: "black" | "white";
}


export default /*#__PURE__*/_defineComponent({
  props: {
    centerLinks: { type: Array, required: false },
    rightLinks: { type: Array, required: false },
    alternateHover: { type: Boolean, required: true },
    facebookUrl: { type: String, required: false },
    instagramUrl: { type: String, required: false },
    twitterUrl: { type: String, required: false },
    theme: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    alternateHover: boolean;
    facebookUrl?: string;
    instagramUrl?: string;
    twitterUrl?: string;
    theme: "black" | "white";
}

const breakpoints = useBreakpoints(breakpointsTailwind);

const showPageLinks = breakpoints.greater("lg");
const showHamburgerButton = breakpoints.smaller("lg");

const appStore = useAppStore();


const loaded = ref(false);

onMounted(() => {
    let last_known_scroll_position = 0;
    let ticking = false;
    loaded.value = true;

    window.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                if (last_known_scroll_position > 50) {
                    appStore.navigation.header.sticky = true;
                } else {
                    appStore.navigation.header.sticky = false;
                }

                ticking = false;
            });

            ticking = true;
        }
    });
});

function currentlyViewing(url: string): boolean {
    const reg = /.+?:\/\/.+?(\/.+?)(?:#|\?|$)/;
    const results = reg.exec(url);
    if (results && results.length > 0) {
        const pathname = results[1];
        return window.location.href.indexOf(pathname) >= 0;
    }
    return false;
}

const logo = computed(() => {
    const hostnameWithoutPort = window.location.host.split(":")[0];
    let sitename = hostnameWithoutPort.split(".")[0];
    let logoname = sitename;

    if (logoname.includes("plugin")) {
        logoname = "plugin";
    } else if (sitename === "localhost" || "hajee-web" || "hajee") {
        logoname = "hajee-logo-" + (1 + Math.floor(Math.random() * 5));
    }

    return logoname;
});

const __returned__ = { breakpoints, showPageLinks, showHamburgerButton, appStore, props, loaded, currentlyViewing, logo, HamburgerButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})